export default {
  en: {
    // Migrated from <i18n> SFC blocks (#6500)
    'grid-title': 'Base Food Analysis',
    'pmix-pct': 'PMIX %',
    'pricing-pct': 'Pricing %',
    'raw-cost-pct': 'Raw Cost %',
    'total-impact': 'Combined Impact %',
    'total-impact-description': 'PMIX, Pricing and Raw Cost add up to the change in Base Food % versus the comparison period',
    'sort-by-magnitude': 'Sort selected metric by size, ignoring sign',
    'decomp-error': 'The decomposition could not be computed for this selection: {reason}',
    'decomp-error-checks': 'the validation checks did not pass',
    'compare-stores-cta': 'Want to compare store to store? Click here.',
    'trend-cta': 'View Base Food Decomp Trend',
    'base-food-decomp-watchlist': 'Watchlist',
    'view-by': 'View By',
    'left-store': 'Left Store',
    'right-store': 'Right Store',
    'left-patch': 'Left Patch',
    'right-patch': 'Right Patch',
    'select-store': 'Select a store or patch to begin',
    'store-grid-title': 'Store {store} - Base Food Details',
    'stores-grid-title': '{stores} - Base Food Details',
    'all-stores': 'All Stores',
    'n-stores': '{count} Stores',
    'deselect-all': 'Deselect All',
    'filtered': 'Filtered',
    'base-food-decomp-compare-patch': 'Patch',
    'base-food-decomp-compare-watchlist': 'Watchlist',
    // Migrated from <i18n> SFC blocks (#6500)
    'no-access': 'You do not have access to this report.',
    'not-subscribed': 'Your Business Unit has not subscribed to Transaction Analytics. Please contact your BU lead for more information.',
    'end-month': 'End Month',
    'impact-pct': 'Impact %',
    'back-to-report': 'Back to Base Food Analysis',
    'chart-title': 'Base Food Analysis Trend',
    'base-food-decomp-trend-select-store-prompt': 'Select a store to view the trend',
    'comp-selector-last-year': 'Last Year',
    'comp-selector-last-month': 'Last Month',
    'tab-overview': 'Overview',
    'tab-compare': 'Compare Stores',
    'tab-trend': 'Trend',
    'back-to-dashboard': 'Back to Dashboard',
    // Legacy camelCase keys
    endingInventory: 'Ending Inventory',
    waste: 'Waste',
    foodOverBase: 'Food Over Base',
    fob: 'FOB',
    fobWithDisc: 'FOB W/ Disc',
    fobWithoutUnexp: 'FOB W/O Unexp',
    fobWithDiscWithoutUnexp: 'FOB W/ Disc & W/O Unexp',
    inventoryVariance: 'Inventory Variance',

    // Food Over Base
    'overlap-metrics': 'Overlap Metrics',
    'food-over-base': 'Food Over Base',
    'by-month': 'By Month',
    'sum-all-dates': 'Sum all Dates',
    'targets': 'Targets',
    'fob-w-disc': 'FOB W/ Disc',
    'fob-w-o-unexp': 'FOB W/O Unexp',
    'fob-w-disc-w-o-unexp': 'FOB W/ Disc & W/O Unexp',

    // Ending Inventory
    'ending-inventory': 'Ending Inventory',
    'for-details-please-use': 'For details, please use',
    'physical-inventory': 'On-Hand',
    'in-the-myqsrsoft-reports-food-menu': 'tab up above',
    'click-a-store-number-to-view-details': 'Click a store number to view Details.',

    // Physical Inventory
    'search': 'Search',
    'for-summarized-report-please-use': 'For summarized report, please use the',

    // Raw Item Count
    'raw-item-count': 'Raw Item Count',
    'legend': 'Legend',
    'column-descriptions': 'Column Descriptions',
    'daily': 'Daily',
    'inventory-counts-should-be-completed-daily-on-these-days': 'Inventory Counts should be completed daily on these days',
    'weekly': 'Weekly',
    'inventory-counts-should-be-completed-weekly-on-these-days': 'Inventory Counts should be completed weekly on these days',
    'monthly': 'Monthly',
    'inventory-counts-should-be-completed-monthly-on-these-days': 'Inventory Counts should be completed monthly on these days',
    'na': 'N/A',
    'column': 'Column',
    'description': 'Description',

    // Inventory Stat
    'inventory-stat': 'Inventory Stat',

    // Raw Waste
    'raw-waste-and-promo': 'Raw Waste & Promo',
    'by-date': 'By Date',
    'summary': 'Summary',
    'detailed': 'Detailed',
    'today': 'Today',
    'raw-waste-summary': 'Raw Waste Summary',
    'raw-waste-and-promo-today': 'Raw Waste & Promo - Today',

    // Completed Waste Summary
    'completed-waste-summary': 'Completed Waste Summary',
    'completed-waste-number': 'Completed Waste #',
    'number-of-completed-items-wasted': 'Number of completed items wasted',
    'completed-waste-cost': 'Completed Waste $',
    'food-and-paper-cost-of-items-wasted': 'Food and Paper Cost of items wasted',
    'promo-number': 'Promo #',
    'number-of-items-promo-d-given-away': "Number of items promo'd (given away)",
    'promo-cost': 'Promo $',
    'food-and-paper-cost-of-items-promo-d': "Food and Paper cost of items promo'd",

    // Completed Waste Detail
    'completed-waste-detail': 'Completed Waste Detail',
    'completed-waste-detail-today': 'Completed Waste Detail - Today',
    'menu-item-number': 'Menu Item Number',
    'standard-menu-item-number': 'Standard Menu Item Number',
    'the-raw-item-name': 'The raw item name',

    // Inventory Selector
    'physical': 'On-Hand',
    'ending': 'Ending',
    'stat': 'Statistics',

    // Transfers By Store
    'transfers-by-store': 'Transfers By Store',
    'food-amt': 'Food Amt',
    'total-dollar-value-of-food-transferred': 'Total dollar value of food transferred',
    'paper-amt': 'Paper Amt',
    'total-dollar-value-of-paper-transferred': 'Total dollar value of paper transferred',
    'ops-supply-amt': 'Ops Supply Amt',
    'total-dollar-value-of-ops-supplies-transferred': 'Total dollar value of ops supplies transferred',
    'non-product-amt': 'Non-Product Amt',
    'total-dollar-value-of-non-product-transferred': 'Total dollar value of non-product transferred',
    'net-transfer-amt': 'Net Transfer Amt',
    'food-amt-paper-amt-ops-supply-amt': 'Food Amt + Paper Amt + Ops Supply Amt',
    'in-transfer-amt': 'In Transfer Amt',
    'transfer-in-amount': 'Transfer In Amount',
    'out-transfer-amt': 'Out Transfer Amt',
    'transfer-out-amount': 'Transfer Out Amount',

    // Transfers Detail
    'transfers-detail': 'Transfers Detail',
    'date-time': 'Date / Time',
    'date-and-time-of-the-transfer': 'Date and Time of the Transfer',
    'other-loc': 'Other Loc',
    'identifies-the-other-store-involved-in-a-transfer': 'Identifies the other store involved in a transfer',
    'mcdonalds-id-from-the-global-account-manager': "McDonalds ID from the Global Account Manager - each manager and above will have an eID",
    'approved-type': 'Appr Type',
    'manual-if-approved-manually': 'Manual if approved manually by the receiving manager, Auto if approved automatically by the system at POS close',
    'wrin-number': 'WRIN #',
    'mcdonalds-worldwide-raw-item-number': 'McDonalds Worldwide Raw Item Number',
    'wrin-suffix': 'WRIN Suffix',
    'suffix-added-to-the-wrin': 'Suffix added to the WRIN to differentiate products in the supply chain. You might have more than one WRIN suffix in the restaurant at a given time',
    'type': 'Type',
    'inventory-item-category': 'Inventory Item Category',
    'transfer-type': 'Transfer Type',
    'shows-whether-the-transfer-was-in-or-out': 'Shows whether the transfer was in or out',
    'qty': 'Qty',
    'quantity-of-raw-items-transferred': 'Quantity of raw items transferred',
    'inventory-unit-amt': 'Inventory Unit Amt',
    'dollar-cost-of-one-inventory-unit': 'Dollar cost of one inventory unit',
    'inventory-cost-total': 'Inventory Cost Total',
    'quantity-x-inventory-unit-amt': 'Quantity x Inventory Unit Amt',
    'wrin': 'WRIN',
    'mcdonalds-worldwide-raw-item-number-and-suffix-identifies-an-individual-raw-item': 'McDonalds Worldwide Raw Item Number and suffix - identifies an individual raw item',

    // Purchases
    'transfers': 'Transfers',
    'purchases': 'Purchases',
    'purchases-detail': 'Purchases Detail',
  },
  es: {
    // Migrated from <i18n> SFC blocks (#6500)
    'grid-title': 'Análisis de Comida Base',
    'pmix-pct': 'PMIX %',
    'pricing-pct': 'Precios %',
    'raw-cost-pct': 'Costo Materia Prima %',
    'total-impact': 'Impacto Combinado %',
    'total-impact-description': 'PMIX, Precios y Costo de Materia Prima suman el cambio en el % de Comida Base respecto al período de comparación',
    'sort-by-magnitude': 'Ordenar la métrica seleccionada por tamaño, sin signo',
    'decomp-error': 'No se pudo calcular la descomposición para esta selección: {reason}',
    'decomp-error-checks': 'las verificaciones de validación no pasaron',
    'compare-stores-cta': '¿Quieres comparar tienda a tienda? Haz clic aquí.',
    'trend-cta': 'Ver Tendencia de Descomposición de Comida Base',
    'base-food-decomp-watchlist': 'Lista de Vigilancia',
    'view-by': 'Ver Por',
    'left-store': 'Tienda Izquierda',
    'right-store': 'Tienda Derecha',
    'left-patch': 'Zona Izquierda',
    'right-patch': 'Zona Derecha',
    'select-store': 'Seleccione una tienda o zona para comenzar',
    'store-grid-title': 'Tienda {store} - Detalles de Comida Base',
    'stores-grid-title': '{stores} - Detalles de Comida Base',
    'all-stores': 'Todas las Tiendas',
    'n-stores': '{count} Tiendas',
    'deselect-all': 'Deseleccionar Todo',
    'filtered': 'Filtrado',
    'base-food-decomp-compare-patch': 'Zona',
    'base-food-decomp-compare-watchlist': 'Lista de Vigilancia',
    // Migrated from <i18n> SFC blocks (#6500)
    'no-access': 'No tiene acceso a este informe.',
    'not-subscribed': 'Su Unidad de Negocio no está suscrita a Analítica de Transacciones. Comuníquese con su líder de BU para más información.',
    'end-month': 'Mes Final',
    'impact-pct': 'Impacto %',
    'back-to-report': 'Volver a Análisis de Comida Base',
    'chart-title': 'Tendencia Análisis Comida Base',
    'base-food-decomp-trend-select-store-prompt': 'Seleccione una tienda para ver la tendencia',
    'comp-selector-last-year': 'Año Pasado',
    'comp-selector-last-month': 'Mes Pasado',
    'tab-overview': 'Resumen',
    'tab-compare': 'Comparar Tiendas',
    'tab-trend': 'Tendencia',
    'back-to-dashboard': 'Volver al Panel',
    endingInventory: 'Inventario Final',
    waste: 'Desperdicio',
    foodOverBase: 'Alimento Sobre Base',
    fob: 'FOB',
    fobWithDisc: 'FOB C/ Desc',
    fobWithoutUnexp: 'FOB S/ Inexp',
    fobWithDiscWithoutUnexp: 'FOB C/ Desc & S/ Inexp',
    inventoryVariance: 'Variación de Inventario',

    'overlap-metrics': 'Superposición de Métricas',
    'food-over-base': 'Comida Sobre la Base',
    'by-month': 'Por Mes',
    'sum-all-dates': 'Sumar Todas las Fechas',
    'targets': 'Objetivos',
    'fob-w-disc': 'FOB Con Descuento',
    'fob-w-o-unexp': 'FOB Sin Explicación',
    'fob-w-disc-w-o-unexp': 'FOB Con Descuento y Sin Explicación',

    'ending-inventory': 'Inventario Final',
    'for-details-please-use': 'Para obtener detalles, utilice',
    'physical-inventory': 'En Mano',
    'in-the-myqsrsoft-reports-food-menu': 'la pestaña de arriba',
    'click-a-store-number-to-view-details': 'Haga clic en un número de tienda para ver los detalles.',

    'search': 'Buscar',
    'for-summarized-report-please-use': 'Para un informe resumido, utilice la',

    'raw-item-count': 'Recuento de Artículos Crudos',
    'legend': 'Leyenda',
    'column-descriptions': 'Descripciones de Columnas',
    'daily': 'Diario',
    'inventory-counts-should-be-completed-daily-on-these-days': 'Los recuentos de inventario deben completarse diariamente en estos días',
    'weekly': 'Semanal',
    'inventory-counts-should-be-completed-weekly-on-these-days': 'Los recuentos de inventario deben completarse semanalmente en estos días',
    'monthly': 'Mensual',
    'inventory-counts-should-be-completed-monthly-on-these-days': 'Los recuentos de inventario deben completarse mensualmente en estos días',
    'na': 'No Disponible',
    'column': 'Columna',
    'description': 'Descripción',

    'inventory-stat': 'Estadísticas de Inventario',

    'raw-waste-and-promo': 'Desperdicio y Promoción',
    'by-date': 'Por Fecha',
    'summary': 'Resumen',
    'detailed': 'Detallado',
    'today': 'Hoy',
    'raw-waste-summary': 'Resumen de Desperdicio de Materias Primas',
    'raw-waste-and-promo-today': 'Desperdicio y Promoción - Hoy',

    'completed-waste-summary': 'Resumen de Desperdicio Completado',
    'completed-waste-number': 'Desperdicio Completado #',
    'number-of-completed-items-wasted': 'Número de artículos completados desperdiciados',
    'completed-waste-cost': 'Desperdicio Completado $',
    'food-and-paper-cost-of-items-wasted': 'Costo de alimentos y papel de los artículos desperdiciados',
    'promo-number': 'Numero de Promoción',
    'number-of-items-promo-d-given-away': 'Número de artículos promocionados (regalados)',
    'promo-cost': 'Costo de Promoción',
    'food-and-paper-cost-of-items-promo-d': 'Costo de alimentos y papel de los artículos promocionados',

    'completed-waste-detail': 'Detalle de Desperdicio Completado',
    'completed-waste-detail-today': 'Detalle de Desperdicio Completado - Hoy',
    'menu-item-number': 'Número de Artículo de Menú',
    'standard-menu-item-number': 'Número de Artículo de Menú Estándar',
    'the-raw-item-name': 'El nombre del artículo crudo',

    'physical': 'En Mano',
    'ending': 'Final',
    'stat': 'Estadísticas',

    'transfers-by-store': 'Transferencias por Tienda',
    'food-amt': 'Monto de Comida',
    'total-dollar-value-of-food-transferred': 'Valor total en dólares de la comida transferida',
    'paper-amt': 'Monto de Papel',
    'total-dollar-value-of-paper-transferred': 'Valor total en dólares del papel transferido',
    'ops-supply-amt': 'Monto de Suministros de Operaciones',
    'total-dollar-value-of-ops-supplies-transferred': 'Valor total en dólares de los suministros de operaciones transferidos',
    'non-product-amt': 'Monto de No Producto',
    'total-dollar-value-of-non-product-transferred': 'Valor total en dólares de no producto transferido',
    'net-transfer-amt': 'Monto de Transferencia Neta',
    'food-amt-paper-amt-ops-supply-amt': 'Monto de Comida + Monto de Papel + Monto de Suministros de Operaciones',
    'in-transfer-amt': 'Monto de Transferencia de Entrada',
    'transfer-in-amount': 'Monto de Transferencia de Entrada',
    'out-transfer-amt': 'Monto de Transferencia de Salida',
    'transfer-out-amount': 'Monto de Transferencia de Salida',

    'transfers-detail': 'Detalle de Transferencias',
    'date-time': 'Fecha / Hora',
    'date-and-time-of-the-transfer': 'Fecha y Hora de la Transferencia',
    'other-loc': 'Otra Ubicación',
    'identifies-the-other-store-involved-in-a-transfer': 'Identifica la otra tienda involucrada en una transferencia',
    'mcdonalds-id-from-the-global-account-manager': 'ID de McDonalds del Gerente de Cuenta Global: cada gerente y superior tendrá un eID',
    'approved-type': 'Tipo Aprobado',
    'manual-if-approved-manually': 'Manual si es aprobado manualmente por el gerente que recibe, Automático si es aprobado automáticamente por el sistema al cierre del POS',
    'wrin-number': 'Numero de Número de Artículo Bruto Mundial',
    'mcdonalds-worldwide-raw-item-number': 'Número de artículo crudo en todo el mundo de McDonalds',
    'wrin-suffix': 'Sufijo del Número de Artículo Bruto Mundial',
    'suffix-added-to-the-wrin': 'Sufijo agregado al Número de Artículo Bruto Mundial para diferenciar productos en la cadena de suministro. Puede tener más de un sufijo WRIN en el restaurante en un momento dado',
    'type': 'Tipo',
    'inventory-item-category': 'Categoría de Artículo de Inventario',
    'transfer-type': 'Tipo de Transferencia',
    'shows-whether-the-transfer-was-in-or-out': 'Muestra si la transferencia fue de entrada o de salida',
    'qty': 'Cantidad',
    'quantity-of-raw-items-transferred': 'Cantidad de artículos crudos transferidos',
    'inventory-unit-amt': 'Monto de la Unidad de Inventario',
    'dollar-cost-of-one-inventory-unit': 'Costo en dólares de una unidad de inventario',
    'inventory-cost-total': 'Costo Total del Inventario',
    'quantity-x-inventory-unit-amt': 'Cantidad x Monto de la Unidad de Inventario',
    'wrin': 'Número de Artículo Bruto Mundial',
    'mcdonalds-worldwide-raw-item-number-and-suffix-identifies-an-individual-raw-item': 'Número de artículo crudo en todo el mundo de McDonalds y sufijo: identifica un artículo crudo individual',

    'transfers': 'Transferencias',
    'purchases': 'Compras',
    'purchases-detail': 'Detalle de Compras',
  },
  fr: {
    // Migrated from <i18n> SFC blocks (#6500)
    'grid-title': 'Analyse des matières de base',
    'pmix-pct': '% PMIX',
    'pricing-pct': '% prix',
    'raw-cost-pct': '% coût matières premières',
    'total-impact': '% impact combiné',
    'total-impact-description': 'Le PMIX, les prix et le coût des matières premières s’additionnent pour donner la variation du % matières de base par rapport à la période de comparaison',
    'sort-by-magnitude': 'Trier l’indicateur sélectionné par ampleur, sans tenir compte du signe',
    'decomp-error': 'Impossible de calculer la décomposition pour cette sélection : {reason}',
    'decomp-error-checks': 'les contrôles de validation ont échoué',
    'compare-stores-cta': 'Vous voulez comparer les restaurants entre eux ? Cliquez ici.',
    'trend-cta': 'Voir la tendance de décomposition des matières de base',
    'base-food-decomp-watchlist': 'Liste de suivi',
    'view-by': 'Afficher par',
    'left-store': 'Restaurant de gauche',
    'right-store': 'Restaurant de droite',
    'left-patch': 'Secteur de gauche',
    'right-patch': 'Secteur de droite',
    'select-store': 'Sélectionnez un restaurant ou un secteur pour commencer',
    'store-grid-title': 'Restaurant {store} - Détails des matières de base',
    'stores-grid-title': '{stores} - Détails des matières de base',
    'all-stores': 'Tous les restaurants',
    'n-stores': '{count} restaurants',
    'deselect-all': 'Tout désélectionner',
    'filtered': 'Filtré',
    'base-food-decomp-compare-patch': 'Correctif',
    'base-food-decomp-compare-watchlist': 'Liste de suivi',
    // Migrated from <i18n> SFC blocks (#6500)
    'no-access': 'Vous n’avez pas accès à ce rapport.',
    'not-subscribed': 'Votre business unit n’est pas abonnée à Transaction Analytics. Veuillez contacter votre responsable BU pour plus d’informations.',
    'end-month': 'Mois de fin',
    'impact-pct': '% impact',
    'back-to-report': 'Retour à l’analyse des matières de base',
    'chart-title': 'Tendance de l’analyse des matières de base',
    'base-food-decomp-trend-select-store-prompt': 'Sélectionnez un restaurant pour afficher la tendance',
    'comp-selector-last-year': 'Année dernière',
    'comp-selector-last-month': 'Mois dernier',
    'tab-overview': 'Vue d’ensemble',
    'tab-compare': 'Comparer les restaurants',
    'tab-trend': 'Tendance',
    'back-to-dashboard': 'Retour au tableau de bord',
    // Legacy camelCase keys
    endingInventory: 'Stock de clôture',
    waste: 'Pertes',
    foodOverBase: 'Coût matières au-dessus de la base',
    fob: 'FOB',
    fobWithDisc: 'FOB avec remises',
    fobWithoutUnexp: 'FOB hors inexpliqué',
    fobWithDiscWithoutUnexp: 'FOB avec remises et hors inexpliqué',
    inventoryVariance: 'Écart de stock',

    // Food Over Base
    'overlap-metrics': 'Indicateurs de recoupement',
    'food-over-base': 'Coût matières au-dessus de la base',
    'by-month': 'Par mois',
    'sum-all-dates': 'Cumuler toutes les dates',
    'targets': 'Objectifs',
    'fob-w-disc': 'FOB avec remises',
    'fob-w-o-unexp': 'FOB hors inexpliqué',
    'fob-w-disc-w-o-unexp': 'FOB avec remises et hors inexpliqué',

    // Ending Inventory
    'ending-inventory': 'Stock de clôture',
    'for-details-please-use': 'Pour le détail, veuillez utiliser',
    'physical-inventory': 'Stock physique',
    'in-the-myqsrsoft-reports-food-menu': 'l’onglet ci-dessus',
    'click-a-store-number-to-view-details': 'Cliquez sur un numéro de restaurant pour afficher le détail.',

    // Physical Inventory
    'search': 'Rechercher',
    'for-summarized-report-please-use': 'Pour le rapport synthétique, veuillez utiliser',

    // Raw Item Count
    'raw-item-count': 'Comptage des articles bruts',
    'legend': 'Légende',
    'column-descriptions': 'Description des colonnes',
    'daily': 'Quotidien',
    'inventory-counts-should-be-completed-daily-on-these-days': 'Les comptages de stock doivent être effectués quotidiennement ces jours-là',
    'weekly': 'Hebdomadaire',
    'inventory-counts-should-be-completed-weekly-on-these-days': 'Les comptages de stock doivent être effectués chaque semaine ces jours-là',
    'monthly': 'Mensuel',
    'inventory-counts-should-be-completed-monthly-on-these-days': 'Les comptages de stock doivent être effectués chaque mois ces jours-là',
    'na': 'S.O.',
    'column': 'Colonne',
    'description': 'Description',

    // Inventory Stat
    'inventory-stat': 'Statistiques de stock',

    // Raw Waste
    'raw-waste-and-promo': 'Pertes brutes et promos',
    'by-date': 'Par date',
    'summary': 'Synthèse',
    'detailed': 'Détaillé',
    'today': 'Aujourd’hui',
    'raw-waste-summary': 'Synthèse des pertes brutes',
    'raw-waste-and-promo-today': 'Pertes brutes et promos - Aujourd’hui',

    // Completed Waste Summary
    'completed-waste-summary': 'Synthèse des pertes sur produits finis',
    'completed-waste-number': 'Nb pertes produits finis',
    'number-of-completed-items-wasted': 'Nombre de produits finis perdus',
    'completed-waste-cost': 'Pertes produits finis $',
    'food-and-paper-cost-of-items-wasted': 'Coût matières et papier des produits perdus',
    'promo-number': 'Nb promos',
    'number-of-items-promo-d-given-away': 'Nombre de produits offerts en promo (donnés)',
    'promo-cost': 'Promo $',
    'food-and-paper-cost-of-items-promo-d': 'Coût matières et papier des produits offerts en promo',

    // Completed Waste Detail
    'completed-waste-detail': 'Détail des pertes sur produits finis',
    'completed-waste-detail-today': 'Détail des pertes sur produits finis - Aujourd’hui',
    'menu-item-number': 'Numéro d’article du menu',
    'standard-menu-item-number': 'Numéro d’article du menu standard',
    'the-raw-item-name': 'Le nom de l’article brut',

    // Inventory Selector
    'physical': 'Stock physique',
    'ending': 'Clôture',
    'stat': 'Statistiques',

    // Transfers By Store
    'transfers-by-store': 'Transferts par restaurant',
    'food-amt': 'Mnt matières',
    'total-dollar-value-of-food-transferred': 'Valeur totale en dollars des matières transférées',
    'paper-amt': 'Mnt papier',
    'total-dollar-value-of-paper-transferred': 'Valeur totale en dollars du papier transféré',
    'ops-supply-amt': 'Mnt fournitures d’exploitation',
    'total-dollar-value-of-ops-supplies-transferred': 'Valeur totale en dollars des fournitures d’exploitation transférées',
    'non-product-amt': 'Mnt hors produit',
    'total-dollar-value-of-non-product-transferred': 'Valeur totale en dollars des éléments hors produit transférés',
    'net-transfer-amt': 'Mnt net des transferts',
    'food-amt-paper-amt-ops-supply-amt': 'Mnt matières + Mnt papier + Mnt fournitures d’exploitation',
    'in-transfer-amt': 'Mnt transferts entrants',
    'transfer-in-amount': 'Montant des transferts entrants',
    'out-transfer-amt': 'Mnt transferts sortants',
    'transfer-out-amount': 'Montant des transferts sortants',

    // Transfers Detail
    'transfers-detail': 'Détail des transferts',
    'date-time': 'Date / heure',
    'date-and-time-of-the-transfer': 'Date et heure du transfert',
    'other-loc': 'Autre site',
    'identifies-the-other-store-involved-in-a-transfer': 'Identifie l’autre restaurant impliqué dans un transfert',
    'mcdonalds-id-from-the-global-account-manager': 'Identifiant McDonald’s issu du Global Account Manager - chaque manager et niveau supérieur possède un eID',
    'approved-type': 'Type d’appr.',
    'manual-if-approved-manually': 'Manuel si approuvé manuellement par le manager qui réceptionne, Auto si approuvé automatiquement par le système à la clôture de la caisse',
    'wrin-number': 'N° WRIN',
    'mcdonalds-worldwide-raw-item-number': 'Numéro mondial d’article brut McDonald’s',
    'wrin-suffix': 'Suffixe WRIN',
    'suffix-added-to-the-wrin': 'Suffixe ajouté au WRIN pour différencier les produits dans la chaîne d’approvisionnement. Plusieurs suffixes WRIN peuvent coexister dans le restaurant à un moment donné',
    'type': 'Type',
    'inventory-item-category': 'Catégorie d’article de stock',
    'transfer-type': 'Type de transfert',
    'shows-whether-the-transfer-was-in-or-out': 'Indique si le transfert était entrant ou sortant',
    'qty': 'Qté',
    'quantity-of-raw-items-transferred': 'Quantité d’articles bruts transférés',
    'inventory-unit-amt': 'Mnt unité de stock',
    'dollar-cost-of-one-inventory-unit': 'Coût en dollars d’une unité de stock',
    'inventory-cost-total': 'Coût total du stock',
    'quantity-x-inventory-unit-amt': 'Quantité x Mnt unité de stock',
    'wrin': 'WRIN',
    'mcdonalds-worldwide-raw-item-number-and-suffix-identifies-an-individual-raw-item': 'Numéro mondial d’article brut McDonald’s et suffixe - identifie un article brut individuel',

    // Purchases
    'transfers': 'Transferts',
    'purchases': 'Achats',
    'purchases-detail': 'Détail des achats',
  },
  'fr-ca': {
    // Migrated from <i18n> SFC blocks (#6500)
    'grid-title': 'Analyse des aliments de base',
    'pmix-pct': '% PMIX',
    'pricing-pct': '% prix',
    'raw-cost-pct': '% coût des matières premières',
    'total-impact': '% impact combiné',
    'total-impact-description': 'Le PMIX, les prix et le coût des matières premières s’additionnent pour donner la variation du % aliments de base par rapport à la période de comparaison',
    'sort-by-magnitude': 'Trier l’indicateur sélectionné par ampleur, sans tenir compte du signe',
    'decomp-error': 'Impossible de calculer la décomposition pour cette sélection : {reason}',
    'decomp-error-checks': 'les vérifications de validation ont échoué',
    'compare-stores-cta': 'Vous voulez comparer les restaurants entre eux? Cliquez ici.',
    'trend-cta': 'Voir la tendance de décomposition des aliments de base',
    'base-food-decomp-watchlist': 'Liste de suivi',
    'view-by': 'Afficher par',
    'left-store': 'Restaurant de gauche',
    'right-store': 'Restaurant de droite',
    'left-patch': 'Secteur de gauche',
    'right-patch': 'Secteur de droite',
    'select-store': 'Sélectionnez un restaurant ou un secteur pour commencer',
    'store-grid-title': 'Restaurant {store} - Détails des aliments de base',
    'stores-grid-title': '{stores} - Détails des aliments de base',
    'all-stores': 'Tous les restaurants',
    'n-stores': '{count} restaurants',
    'deselect-all': 'Tout désélectionner',
    'filtered': 'Filtré',
    'base-food-decomp-compare-patch': 'Correctif',
    'base-food-decomp-compare-watchlist': 'Liste de suivi',
    // Migrated from <i18n> SFC blocks (#6500)
    'no-access': 'Vous n’avez pas accès à ce rapport.',
    'not-subscribed': 'Votre unité d’affaires n’est pas abonnée à Transaction Analytics. Veuillez communiquer avec le responsable de votre unité d’affaires pour plus d’informations.',
    'end-month': 'Mois de fin',
    'impact-pct': '% impact',
    'back-to-report': 'Retour à l’analyse des aliments de base',
    'chart-title': 'Tendance de l’analyse des aliments de base',
    'base-food-decomp-trend-select-store-prompt': 'Sélectionnez un restaurant pour afficher la tendance',
    'comp-selector-last-year': 'An dernier',
    'comp-selector-last-month': 'Mois dernier',
    'tab-overview': 'Aperçu',
    'tab-compare': 'Comparer les restaurants',
    'tab-trend': 'Tendance',
    'back-to-dashboard': 'Retour au tableau de bord',
    // Legacy camelCase keys
    endingInventory: 'Inventaire de fermeture',
    waste: 'Pertes',
    foodOverBase: 'Aliments au-dessus de la base',
    fob: 'FOB',
    fobWithDisc: 'FOB avec rabais',
    fobWithoutUnexp: 'FOB sans inexpliqué',
    fobWithDiscWithoutUnexp: 'FOB avec rabais et sans inexpliqué',
    inventoryVariance: 'Écart d’inventaire',

    // Food Over Base
    'overlap-metrics': 'Indicateurs de chevauchement',
    'food-over-base': 'Aliments au-dessus de la base',
    'by-month': 'Par mois',
    'sum-all-dates': 'Cumuler toutes les dates',
    'targets': 'Cibles',
    'fob-w-disc': 'FOB avec rabais',
    'fob-w-o-unexp': 'FOB sans inexpliqué',
    'fob-w-disc-w-o-unexp': 'FOB avec rabais et sans inexpliqué',

    // Ending Inventory
    'ending-inventory': 'Inventaire de fermeture',
    'for-details-please-use': 'Pour le détail, veuillez utiliser',
    'physical-inventory': 'Inventaire en main',
    'in-the-myqsrsoft-reports-food-menu': 'l’onglet ci-dessus',
    'click-a-store-number-to-view-details': 'Cliquez sur un numéro de restaurant pour afficher le détail.',

    // Physical Inventory
    'search': 'Rechercher',
    'for-summarized-report-please-use': 'Pour le rapport sommaire, veuillez utiliser',

    // Raw Item Count
    'raw-item-count': 'Décompte des articles bruts',
    'legend': 'Légende',
    'column-descriptions': 'Description des colonnes',
    'daily': 'Quotidien',
    'inventory-counts-should-be-completed-daily-on-these-days': 'Les décomptes d’inventaire doivent être effectués quotidiennement ces jours-là',
    'weekly': 'Hebdomadaire',
    'inventory-counts-should-be-completed-weekly-on-these-days': 'Les décomptes d’inventaire doivent être effectués chaque semaine ces jours-là',
    'monthly': 'Mensuel',
    'inventory-counts-should-be-completed-monthly-on-these-days': 'Les décomptes d’inventaire doivent être effectués chaque mois ces jours-là',
    'na': 'S.O.',
    'column': 'Colonne',
    'description': 'Description',

    // Inventory Stat
    'inventory-stat': 'Statistiques d’inventaire',

    // Raw Waste
    'raw-waste-and-promo': 'Pertes brutes et promos',
    'by-date': 'Par date',
    'summary': 'Sommaire',
    'detailed': 'Détaillé',
    'today': 'Aujourd’hui',
    'raw-waste-summary': 'Sommaire des pertes brutes',
    'raw-waste-and-promo-today': 'Pertes brutes et promos - Aujourd’hui',

    // Completed Waste Summary
    'completed-waste-summary': 'Sommaire des pertes sur produits finis',
    'completed-waste-number': 'Nb pertes produits finis',
    'number-of-completed-items-wasted': 'Nombre de produits finis perdus',
    'completed-waste-cost': 'Pertes produits finis $',
    'food-and-paper-cost-of-items-wasted': 'Coût des aliments et du papier des produits perdus',
    'promo-number': 'Nb promos',
    'number-of-items-promo-d-given-away': 'Nombre de produits donnés en promo',
    'promo-cost': 'Promo $',
    'food-and-paper-cost-of-items-promo-d': 'Coût des aliments et du papier des produits donnés en promo',

    // Completed Waste Detail
    'completed-waste-detail': 'Détail des pertes sur produits finis',
    'completed-waste-detail-today': 'Détail des pertes sur produits finis - Aujourd’hui',
    'menu-item-number': 'Numéro d’article du menu',
    'standard-menu-item-number': 'Numéro d’article du menu standard',
    'the-raw-item-name': 'Le nom de l’article brut',

    // Inventory Selector
    'physical': 'Inventaire en main',
    'ending': 'Fermeture',
    'stat': 'Statistiques',

    // Transfers By Store
    'transfers-by-store': 'Transferts par restaurant',
    'food-amt': 'Mnt aliments',
    'total-dollar-value-of-food-transferred': 'Valeur totale en dollars des aliments transférés',
    'paper-amt': 'Mnt papier',
    'total-dollar-value-of-paper-transferred': 'Valeur totale en dollars du papier transféré',
    'ops-supply-amt': 'Mnt fournitures d’exploitation',
    'total-dollar-value-of-ops-supplies-transferred': 'Valeur totale en dollars des fournitures d’exploitation transférées',
    'non-product-amt': 'Mnt hors produit',
    'total-dollar-value-of-non-product-transferred': 'Valeur totale en dollars des éléments hors produit transférés',
    'net-transfer-amt': 'Mnt net des transferts',
    'food-amt-paper-amt-ops-supply-amt': 'Mnt aliments + Mnt papier + Mnt fournitures d’exploitation',
    'in-transfer-amt': 'Mnt transferts entrants',
    'transfer-in-amount': 'Montant des transferts entrants',
    'out-transfer-amt': 'Mnt transferts sortants',
    'transfer-out-amount': 'Montant des transferts sortants',

    // Transfers Detail
    'transfers-detail': 'Détail des transferts',
    'date-time': 'Date / heure',
    'date-and-time-of-the-transfer': 'Date et heure du transfert',
    'other-loc': 'Autre emplacement',
    'identifies-the-other-store-involved-in-a-transfer': 'Identifie l’autre restaurant visé par un transfert',
    'mcdonalds-id-from-the-global-account-manager': 'Identifiant McDonald’s provenant du Global Account Manager - chaque gérant et niveau supérieur possède un eID',
    'approved-type': 'Type d’appr.',
    'manual-if-approved-manually': 'Manuel si approuvé manuellement par le gérant qui reçoit, Auto si approuvé automatiquement par le système à la fermeture du PDV',
    'wrin-number': 'N° WRIN',
    'mcdonalds-worldwide-raw-item-number': 'Numéro mondial d’article brut McDonald’s',
    'wrin-suffix': 'Suffixe WRIN',
    'suffix-added-to-the-wrin': 'Suffixe ajouté au WRIN pour différencier les produits dans la chaîne d’approvisionnement. Plusieurs suffixes WRIN peuvent se trouver dans le restaurant en même temps',
    'type': 'Type',
    'inventory-item-category': 'Catégorie d’article d’inventaire',
    'transfer-type': 'Type de transfert',
    'shows-whether-the-transfer-was-in-or-out': 'Indique si le transfert était entrant ou sortant',
    'qty': 'Qté',
    'quantity-of-raw-items-transferred': 'Quantité d’articles bruts transférés',
    'inventory-unit-amt': 'Mnt unité d’inventaire',
    'dollar-cost-of-one-inventory-unit': 'Coût en dollars d’une unité d’inventaire',
    'inventory-cost-total': 'Coût total de l’inventaire',
    'quantity-x-inventory-unit-amt': 'Quantité x Mnt unité d’inventaire',
    'wrin': 'WRIN',
    'mcdonalds-worldwide-raw-item-number-and-suffix-identifies-an-individual-raw-item': 'Numéro mondial d’article brut McDonald’s et suffixe - identifie un article brut individuel',

    // Purchases
    'transfers': 'Transferts',
    'purchases': 'Achats',
    'purchases-detail': 'Détail des achats',
  },
};
